import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class StrikePriceUseCase extends BaseUseCase {
    constructor(marginRepo) {
        super();
        this.marginRepo = marginRepo;
    }
    async fetchResult(req) {
        return await this.marginRepo.getStrikePriceList(req);
    }
}
export default StrikePriceUseCase;
